import { Pipe, PipeTransform } from '@angular/core';
import { FuseUtils } from '@fuse/utils';
import { DatePipe } from '@angular/common';

@Pipe({name: 'AustraliaDateFormat'})
export class AustralianDateFormat extends DatePipe implements PipeTransform
{
    /**
     * Transform
     *
     * @param {any[]} mainArr
     * @param {string} searchText
     * @param {string} property
     * @returns {any}
     */
    transform(value: any, args?: any): any {
        return super.transform(value, "EEE, dd-MMM-yyyy");
    }
}

@Pipe({name: 'AustraliaTimeFormat'})
export class AustralianTimeFormat extends DatePipe implements PipeTransform
{
    /**
     * Transform
     *
     * @param {any[]} mainArr
     * @param {string} searchText
     * @param {string} property
     * @returns {any}
     */
    transform(value: any, args?: any): any {
        return super.transform(value, "HH:mm:ss");
    }
}